import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useTenantNavigation } from '../../hooks/useTenantNavigation';
import Cookies from 'js-cookie';
import { CircularProgress, Box, Paper, Typography } from '@mui/material';
import { ErpContext } from '../../context/ErpContext';

/**
 * Componente que protege las rutas del portal de clientes
 * - Verifica que exista token de cliente válido
 * - Si no hay token o es inválido → redirige a login
 * - Si hay token válido → permite acceso
 * - IMPORTANTE: Bloquea acceso si hay sesión de admin activa
 */
const ClienteProtectedRoute = ({ children }) => {
  const { tenant } = useParams();
  const navigate = useTenantNavigation();
  const { user } = React.useContext(ErpContext);
  const { verificarSesionCliente } = React.useContext(ErpContext);
  
  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const tenantActual = tenant || Cookies.get('tenantURL') || 'tours';

  useEffect(() => {
    const verificarAcceso = async () => {
      // BLOQUEO CRÍTICO: Si hay sesión de admin activa, NO permitir acceso al portal de clientes
      if (user) {
        console.warn('⚠️ [ClienteProtectedRoute] Sesión de admin detectada. Bloqueando acceso al portal de clientes.');
        setIsValid(false);
        setLoading(false);
        return;
      }

      // Verificar token de cliente
      const token = localStorage.getItem('clienteToken');
      if (!token) {
        setIsValid(false);
        setLoading(false);
        return;
      }

      // Verificar que el token sea válido
      try {
        const sesionValida = await verificarSesionCliente();
        setIsValid(sesionValida);
      } catch (error) {
        console.error('Error verificando sesión de cliente:', error);
        setIsValid(false);
      } finally {
        setLoading(false);
      }
    };

    verificarAcceso();
  }, [user, verificarSesionCliente]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <Paper sx={{ p: 4, borderRadius: '16px' }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Verificando sesión...</Typography>
        </Paper>
      </Box>
    );
  }

  // Si hay sesión de admin o no hay token válido, redirigir a login
  if (!isValid) {
    return <Navigate to={`/${tenantActual}/mispagos/login`} replace />;
  }

  // Token válido y sin sesión admin → permitir acceso
  return children;
};

export default ClienteProtectedRoute;













